import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChip from "../BaseChipComponents/AppliedFilterChipBase";
import { getExtendedMetadataKey } from "utils/extendedMetadata";
import React from "react";
import { buildHoverList, CHIP_AGGREGATION_THRESHOLD, chipAggregatedLabel, chipItemLabel, sortAlphabetically, useChipFiltersStore } from "../BaseChipComponents/chipUtils";

export const ExtendedMetadataGroupedAppliedFilterChip = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);

    const extendedMetadataKey = getExtendedMetadataKey(props.item.filterKey);
    const groupedValue = extendedMetadataKey
        ? applicationFiltersStore.extendedMetadataGrouped?.[extendedMetadataKey]
        : undefined;

    if (!groupedValue || groupedValue.values.length === 0) return null;

    const handleRemove = () => {
        if (!extendedMetadataKey) return;

        const updatedGrouped = {
            ...(applicationFiltersStore.extendedMetadataGrouped ?? {}),
        };
        delete updatedGrouped[extendedMetadataKey];

        applicationFiltersStore.setExtendedMetadataGrouped(
            Object.keys(updatedGrouped).length > 0 ? updatedGrouped : undefined,
        );
        applicationFiltersStore.resetByKey(
            `extendedMetadata.${extendedMetadataKey}`,
        );
    };

    const { values, contains } = groupedValue;
    const title = props.item.title;

    if (values.length > CHIP_AGGREGATION_THRESHOLD) {
        const sortedValues = sortAlphabetically(values);
        const label = chipAggregatedLabel(values.length, `${title}s`, !contains);

        return (
            <AppliedFilterChip
                disabled={props.disabled}
                isApplicable={props.isApplicable}
                onRemove={handleRemove}
                tooltipContent={buildHoverList(sortedValues)}
            >
                {label}
            </AppliedFilterChip>
        );
    }

    return (
        <AppliedFilterChip
            disabled={props.disabled}
            isApplicable={props.isApplicable}
            onRemove={handleRemove}
        >
            {chipItemLabel(title, values.join(", "), !contains)}
        </AppliedFilterChip>
    );
});
